'use strict';

let initialState = {
  accountConfig: {
    required : true,
    accountId : null,
    disableDropdown: true,
    showAccountSelection: false,
    editPage: true
  },
  deliveryMode: [
    {val: "email", label: "Email"},
    {val: "sms", label: "SMS"}
  ],
  deliveryHours: [],
  isImmediateOptions: [
    {val: true, label: 'Immediately'},
    {val: false, label: 'Scheduled'}
  ],
  deliveryUnits: [
    {val: 'day', label: 'Days'},
    {val: 'week', label: 'Weeks'},
    {val: 'month', label: 'Months'}
  ],
  selectedEmails: []
};

let defaultEmailDeliverySenderAddress = {
  fromEmailAddress: "noreply@yourreviewsurvey.com"
}

let formatHour = hour => {
  var suffix = hour < 12 ? 'AM' : 'PM';
  if (hour > 12) {
    hour -= 12
  }
  return hour + ':00 ' + suffix;
};
for (var i = 0; i < 24; ++i) {
  initialState.deliveryHours.push({
    val: i,
    label: formatHour(i)
  })
}

module.exports = function(angularModule) {
  angularModule.controller('CampaignEditorCtrl', function($scope, campaign, $state, $stateParams, reviewGenService,
      stringService, updateService, accountsService, locationService, $timeout, campaignManagerService,
      confirmService, user, isSharedDefault, RGSenderConfigService, accountConfiguration) {
    var vm = this;
    angular.copy(initialState, vm);
    vm.mode = $stateParams.mode;
    vm.pageStrings = stringService.adminStrings(vm.mode);
    vm.confirmedNPSChange = false;

    vm.showVisibility = isSharedDefault || _.contains(user.permissions, 'ReviewBuilderVisibilityAdmin')

    vm.accountConfiguration = accountConfiguration

    vm.defaultSenderEmail = function(){
      let found = vm.customSenderEmailAddresses.find((address) => address.isDefault)
      if (found) {
        return found.fromEmailAddress
      } else {
        return defaultEmailDeliverySenderAddress.fromEmailAddress
      }
    }

    vm.defaultSenderName = function() {
      let found = vm.customSenderEmailAddresses.find((address) => address.isDefault)
      if (found)
        return found.senderName
      else {
        return vm.accountConfiguration.senderName
      }
    }

    locationService.locationsAndGroups().then(function (data) {
      var availableGroups = data.groups.filter(group => !group.id.startsWith("all-"))
      availableGroups = _.sortBy(availableGroups, 'name')

      vm.allGroup = {
        id: locationService.defaultGroupId(),
        name: "All",
        totalLocations: data.locations.length
      }
      if (vm.mode == "create") {
        vm.campaign.groupId = vm.allGroup.id
      }
      vm.groups = [vm.allGroup].concat(availableGroups);
    });


    var validSenderAddresses = []
    if (accountConfiguration.customSenderEmailAddresses) {
      validSenderAddresses = validSenderAddresses.concat(accountConfiguration.customSenderEmailAddresses.filter((senderAddress) => senderAddress.verificationStatus == 'Success'))
    }
    validSenderAddresses.unshift({senderName: accountConfiguration.senderName, fromEmailAddress: "noreply@yourreviewsurvey.com"})
    vm.customSenderEmailAddresses = validSenderAddresses

    $scope.$on('createEntityEvent',function(e){
      vm.createEditCampaign(true);
    });

    if (vm.mode == 'create') {
      accountsService.getCurrentAccount().then(function (accountId) {
        vm.accountConfig.accountId = accountId;
      });
    }

    vm.isActive = function(formElemId){
      return true;
    }

    vm.calculateSendingType = deliveryMethod => {
      deliveryMethod.isImmediate = deliveryMethod.deliveryDelay === 0;
    };

    vm.defaultCampaign = function () {
      return {
        name: '',
        accountId: vm.accountConfig.accountId,
        isActive: false,
        isShared: isSharedDefault,
        oneReviewPerContact: false,
        useMostRecentReview: false,
        deliveryMethods: [
          {
            _id: {
              '$oid': "tmp" + new Date().getTime()
            },
            deliveryDelay: 0,
            deliveryDelayType: "day",
            fromAddress: vm.defaultSenderEmail(),
            senderName: vm.defaultSenderName(),
            subject:  "Please tell us your thoughts {{firstName}}!",
            templateId: vm.emailTemplates && vm.emailTemplates.length ? vm.emailTemplates[0]._id : "",
            type: "email",
            message: "Please tell us your thoughts! Reply 'STOP' to opt-out from text messages. \n {{{ formUrl }}}",
            isImmediate: true      // wonder if this can be done with ng-init in the form
          },
          {
            _id: {
              '$oid': "tmp2" + new Date().getTime()
            },
            deliveryDelay: 1,
            deliveryDelayType: 'week',
            deliveryHour: 9,
            fromAddress: vm.defaultSenderEmail(),
            senderName: vm.defaultSenderName(),
            subject:  "Please tell us your thoughts {{firstName}}!",
            templateId: vm.emailTemplates && vm.emailTemplates.length ? vm.emailTemplates[0]._id : "",
            type: "email",
            message: "Please tell us your thoughts! Reply 'STOP' to opt-out from text messages. \n {{{ formUrl }}}",
            isImmediate: false      // wonder if this can be done with ng-init in the form
          }
        ],
        deleted: false,
        groupId: locationService.defaultGroupId()
      }
    };

    vm.setOneReviewPerContact = function(bool) {
      $timeout(function () {
        if (!!bool) {
          vm.campaign.useMostRecentReview = false;
        }
        vm.campaign.oneReviewPerContact = bool
      });
    };

    vm.removeDeliveryMethod = function(index) {
      vm.campaign.deliveryMethods.splice(index, 1);
    };
    
    vm.addDeliveryMethod = function() {
      let method = vm.defaultCampaign().deliveryMethods[0]
      method.fromEmailAddress = vm.defaultSenderEmail()
      method.senderName = vm.defaultSenderName()
      vm.campaign.deliveryMethods.push(method);
    };

    vm.createEditCampaign = function(isFormValid) {

      if (isFormValid && !vm.confirmedNPSChange && vm.campaign._id && vm.originalForm && _.contains(vm.originalForm.featureTags, "NPS") && !_.contains(vm.selectedForm.featureTags, "NPS")) {
        confirmService.confirm("Confirm form change", `
            The form you have selected doesn't include a Net Promoter Score field - if you make this change,
            you will no longer be able to collect Net Promoter data - proceed?
          `,
          confirmService.WARNING
        ).then(response => {
          vm.confirmedNPSChange = response;
          if (vm.confirmedNPSChange) {
            vm.createEditCampaign(isFormValid);
          }
        })

        return;
      }

      vm.state = 'PendingConfirmation';
      vm.formSubmitted = true;

      if(!isFormValid){
        return;
      }

      let onSuccess = function(campaign) {
        vm.newCampaign = campaign;
        var updateInfo = {
          status: "Active",
          type: "campaign",
          title: "Campaign",
          destinationRole: "manage",
          notificationType: "detail",
          actions: [{action: vm.mode}],
          entity: vm.newCampaign,
          id: vm.newCampaign._id.$oid,
          name: vm.newCampaign.name,
          accountId: accountsService.getCurrentAccount().$$state.value,
          searchParam: vm.newCampaign.name
        };
        updateService.registerSuccessfulUpdate(updateInfo,true);

        $state.go("reviewBuilder.campaign.dashboard", {campaignId: vm.newCampaign._id.$oid}, {reload: true});

        let remappedEmailTemplates = {};
        for (let i = 0; i < vm.campaign.deliveryMethods.length; ++i) {
          remappedEmailTemplates[vm.newCampaign.deliveryMethods[i]._id.$oid] = vm.selectedEmails[vm.campaign.deliveryMethods[i]._id.$oid]
        }
        vm.selectedEmails = remappedEmailTemplates;
        vm.campaign = vm.newCampaign;

        vm.state = 'Success';
      };

      let handleError = function () {
        vm.errorMsg = 'Error '+vm.pageStrings.errorAction+' campaign!';
        vm.errorDetail = 'Please campaign support';
        vm.state = 'CampaignEditing';
      };

      let submittedCampaign = angular.copy(vm.campaign);

      if (submittedCampaign.oneReviewPerContact != true) submittedCampaign.oneReviewPerContact = false

      submittedCampaign.deliveryMethods.map(method => {
        if (method.senderAddressId) {
          if (method.senderAddressId.$oid == 'default') {
            delete method.senderAddressId
          }
        }
        if (method._id.$oid.substr(0, 3) == 'tmp') delete method._id
      });

      campaignManagerService.saveCampaign(submittedCampaign).then(onSuccess, handleError);
    };

    vm.onSenderEmailSelect = function(deliveryMethod) {
      let selectedAddress = vm.customSenderEmailAddresses.find(address => address.fromEmailAddress == deliveryMethod.fromAddress)
      if (selectedAddress) {
        deliveryMethod.senderName = selectedAddress.senderName
      }
    }

    vm.hasEnoughDeliveryMethods = function() {
      return vm.campaign.deliveryMethods.length > 1;
    };


    vm.cancel = function(){
      window.history.back();
    };

    vm.hasError = function (input) {
      if (!input) return;
      return input.$invalid && (!input.$pristine || vm.formSubmitted);
    };

    function activate() {
      vm.state = 'Loading';
      vm.formSubmitted = false;
      if(vm.mode == 'create'){
        vm.campaign = vm.defaultCampaign();
        // populate default email templates
        reviewGenService.searchEmailTemplates({limitOpt: 1}).then(response => {
          vm.campaign.deliveryMethods.map(method => {
            method.templateId = response.templates[0]._id;
            vm.selectEmail(method._id.$oid)(response.templates[0]);
          })
        })
        //populate default form
        reviewGenService.searchReviewForms({limitOpt: 1}).then(response => {
          if (response.data.forms.length > 0) {
            vm.campaign.formId = response.data.forms[0]._id;
            vm.selectForm(response.data.forms[0]);
          }
        })
      } else {
        vm.campaign = angular.copy(campaign);
        vm.campaign.deliveryMethods.forEach(function(method) {
          // legacy old delivery methods
          if (method.fromAddress == 'support@chatmeter.com') {
            method.fromAddress = vm.defaultSenderEmail()
          }
        })

        // fetch details for all existing email templates
        vm.campaign.deliveryMethods.map(method => {
          reviewGenService.getEmailTemplates(method.templateId).then(email => {
            vm.selectEmail(method._id.$oid)(email);
          });
        })

        vm.accountConfig.accountId = vm.campaign.accountId;

        if (vm.campaign.formId) {
          reviewGenService.getReviewForm(vm.campaign.formId).then(response => {
            vm.selectForm(response.data);
            vm.originalForm = response.data;
          });
        }
        if (! angular.isDefined(vm.campaign.groupId)) {
          vm.campaign.groupId = locationService.defaultGroupId()
        }

      }

      // Need to set some temporary state for the "immediate / scheduled" dropdown
      vm.campaign.deliveryMethods.map(method => method.isImmediate = method.deliveryDelay == 0);

      vm.state = 'CampaignEditing';
    }

    vm.selectEmail = function(id) {
       return email => {
         vm.selectedEmails[id] = email
         _.find(vm.campaign.deliveryMethods, method => method._id.$oid == id).templateId = email._id;
       }
    }

    vm.selectForm = function(form) {
      vm.selectedForm = form;
      vm.campaign.formId = form._id;
    };

    vm.previewFormOrTemplate = function(id, type){
      $('#previewModal').modal();
      vm.modalState = "Loading";
      if(type == "emailTemplate") {
        previewEmailTemplate(id)
      }
      if(type == "form") {
        previewForm(id)
      }
    };

    activate();

    function previewEmailTemplate(emailTemplateId) {
      reviewGenService.getEmailTemplates(emailTemplateId).then(function(emailTemplate) {
        reviewGenService.previewEmailTemplate(emailTemplate.content).then(function(response) {
          vm.modalState = "Done";
          var template = response.data;
          var iframe = $("#previewFormOrTemplate")[0], iframedoc = iframe.contentDocument || iframe.contentWindow.document;
          $timeout(function () {
            iframedoc.open();
            iframedoc.write(template);
            iframedoc.close();
          });
        });
      });
    }
  })
};
